import { Component } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';

@Component({
  selector: 'mealsuite-menu-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'menuboard-v3';

  constructor() {
    setTimeout(() => {
      try {
        SplashScreen.hide();
      } catch {
        console.log('dont have splash screen');
      }
    }, 5000);
  }
}
